<template>
	<div>
		<Top2 titletext="欢迎登录"></Top2>
		<div class="loginback">
			<div class="wd-container wd-flex wd-row-between">
				<div class="adimg">
					<el-image :src="adpic" class="img" fit="fill">
						<div slot="error" class="image-slot">
							<i class="el-icon-picture-outline"></i>
						</div>
					</el-image>
				</div>
				<div class="form">
					<div class="title">账户登录</div>
					<div class="main">
						<el-form>
							<el-form-item><el-input ref="mobile" placeholder="手机号" v-model="mobile" @keyup.enter.native="go('pass')"></el-input></el-form-item>
							<el-form-item><el-input ref="pass" placeholder="密码" v-model="pass" type="password" @keyup.enter.native="go('valcode')"></el-input></el-form-item>
							<el-form-item>
								<el-row>
									<el-col :span="16">
										<el-input ref="valcode" placeholder="请输入验证码" maxlength="4" v-model="valcode" @keyup.enter.native="loginin"></el-input>
									</el-col>
									<el-col :span="8"><s-identify :content-height="40" :identify-code="identifyCode" @click.native.prevent="refreshCode" /></el-col>
								</el-row>
							</el-form-item>
							<el-form-item><el-button type="primary" size="medium" class="wd-width-percent-100" :loading="opting" @click="loginin">登 录</el-button></el-form-item>
						</el-form>
					</div>
					<div class="reghint">
						<el-link type="info" @click="mima"><span>忘记密码?</span></el-link>
						<el-link type="primary" @click="reg">
							<span>立即注册</span>
							<i class="wd-icon wd-m-l-10">&#xe632;</i>
						</el-link>
					</div>
				</div>
			</div>
		</div>
		<Footer></Footer>
	</div>
</template>

<script>
import Top2 from '@/components/layout/Top2.vue';
import Footer from '@/components/layout/Footer.vue';
import SIdentify from '@/components/Identify';
import {mapState} from 'vuex'
export default {
	computed:{...mapState(["logininfo"])},
	name: 'Login',
	components: {
		Top2,
		Footer,
		SIdentify
	},
	data() {
		return {
			adpic: 'img/loginform.png',
			mobile: '',
			pass: '',
			valcode: '',
			msg: '',
			identifyCodes: '1234567890',
			identifyCode: '',
			redirect: '/member',
			opting:false
		};
	},
	methods: {
		go(code) {
			if (code == 'usercode') {
				this.$refs.usercode.focus();
			} else if (code == 'userpass') {
				this.$refs.userpass.focus();
			} else if (code == 'valcode') {
				this.$refs.valcode.focus();
			}
		},
		// 生成一个随机数
		randomNum(min, max) {
			return Math.floor(Math.random() * (max - min) + min);
		},
		refreshCode() {
			this.identifyCode = '';
			this.makeCode(this.identifyCodes, 4);
		},
		makeCode(o, l) {
			for (let i = 0; i < l; i++) {
				this.identifyCode += this.identifyCodes[this.randomNum(0, this.identifyCodes.length)];
			}
		},
		onSuccessa() {
			this.msg = 'login success';
		},
		onFaila() {
			this.msg = '';
		},
		onRefresha() {
			this.msg = '';
		},
		reg() {
			this.$router.push('/reg');
		},
		mima(){
			this.$router.push("/mima");
		},
		loginin() {
			this.opting=true;
			if (this.mobile == '') {
				this.opting=false;
				this.$wd_msg('请输入手机号码');
				return;
			}
			if (this.pass == '') {
				this.opting=false;
				this.$wd_msg('请输入密码');
				return;
			}
			if (this.valcode == '') {
				this.opting=false;
				this.$wd_msg('请输入验证码');
				return;
			}
			if (this.valcode !== this.identifyCode) {
				this.opting=false;
				this.$wd_msg('验证码输入错误');
				return;
			}
			var indata = {
				mobile: this.mobile,
				pass: this.pass,
				verifycode: this.valcode,
				flag: 'web'
			};
			this.$wd_request('loginin', indata)
				.then(data => {
					var tokentime = this.$weidajs.getDateTime();
					let ldata = {
						islogin: true,
						token: data.token,
						uuid: '',
						version: '',
						tokentime: tokentime,
						myinfo: data.value
					};
					localStorage.setItem('wdmem', JSON.stringify(ldata));
					this.$store.commit('login', ldata);
					this.$router.push(this.redirect);
				})
				.catch(data => {
					this.opting=false;
					this.$message({
						message: data.msg,
						type: "error"
					})
					this.refreshCode();
				});
		}
	},
	created() {
		var param = this.$route.query.redirect || '';
		if (param !== '') {
			this.redirect = param;
		}
		this.refreshCode();
		if (!this.$weidajs.isEmpty(this.logininfo.companyinfo.webloginpicurl)){
			this.adpic =this.$wdpicurl(this.logininfo.companyinfo.webloginpicurl);
		}else{
			this.$wd_request("company")
			.then(data=>{
				if (!this.$weidajs.isEmpty(data.value.webloginpicurl)){
					this.adpic =this.$wdpicurl(data.value.webloginpicurl);		
				}
			})
		}
	}
};
</script>

<style lang="scss" scoped>
.loginback {
	background: #bf1919;
	position: relative;
	height: 400px;
	.adimg {
		width: 620px;
		height: 390px;
		.img {
			margin-top: 17px;
			width: 620px;
			height: 366px;
		}
	}
	.form {
		background-color: #ffffff;
		width: 346px;
		background: white;
		margin-top: 17px;
		height: 356px;
		.title {
			color: #ff4c4c;
			font-size: 18px;
			font-weight: bold;
			height: 64px;
			line-height: 64px;
			text-align: center;
		}
		.main {
			height: 230px;
			padding: 10px 20px;
		}
		.reghint {
			color: #ff4c4c;
			font-size: 16px;
			display: flex;
			justify-content: space-between;
			padding: 0 20px;
		}
	}
}
</style>
